import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppleProfilePresetType, PresetModelType } from '@era/stores';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'ml-mdm-settings-profile-preset-list-item',
  templateUrl: './settings-profile-preset-list-item.component.html',
  styleUrls: ['./settings-profile-preset-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, FaIconComponent],
})
export class SettingsProfilePresetListItemComponent<T extends AppleProfilePresetType> {
  public readonly preset = input.required<PresetModelType<T>>();
  public readonly profileType = input.required<T>();
  public readonly allowDelete = input(false);
  public readonly displayField = input('id'); // Field name to display, e.g., 'id' or 'SSID_STR'

  readonly deleted = output<PresetModelType<T>>();

  public delete() {
    this.deleted.emit(this.preset());
  }

  public getDisplayValue(): string {
    const preset = this.preset();
    if (!preset) {
      return '';
    }
    // Access the field dynamically - all presets have id, wifi also has SSID_STR
    const displayField = this.displayField();
    if (displayField === 'id' && 'id' in preset) {
      return preset.id || '';
    }
    if (displayField === 'SSID_STR' && 'SSID_STR' in preset) {
      return preset.SSID_STR || '';
    }
    return '';
  }
}
